import { SubmitBookingFormData } from 'src/components/checkout/SectionCheckout';
import SelectedProduct from 'src/entities/cart/request/SelectedProduct';
import CustomerOrder from 'src/entities/customer/CustomerOrder';
import { action } from 'src/store/actions';

export const ADD_CART = 'ADD_CART';
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
export const REMOVE_ALL_FROM_CART = 'REMOVE_ALL_FROM_CART';
export const CHANGE_PRODUCT_QUANTITY = 'CHANGE_PRODUCT_QUANTITY';
export const CHANGE_PRODUCT_CUSTOM_FIELD_VALUE = 'CHANGE_PRODUCT_CUSTOM_FIELD_VALUE';
export const UPDATE_SHOPPING_CART = 'UPDATE_SHOPPING_CART';
export const CLEAR_SHOPPING_CART = 'CLEAR_SHOPPING_CART';
export const RESET_SHOPPING_CART = 'RESET_SHOPPING_CART';
export const ORDER_AGAIN = 'ORDER_AGAIN';
export const SUBMIT_BOOKING = 'SUBMIT_BOOKING';
export const SUCCESS_SUBMIT_BOOKING = 'SUCCESS_SUBMIT_BOOKING';
export const REQUEST_ORDERING_CALC = 'REQUEST_ORDERING_CALC';
export const SUCCESS_ORDERING_CALC = 'SUCCESS_ORDERING_CALC';
export const FAILURE_ORDERING_CALC = 'FAILURE_ORDERING_CALC';

export const addToCart = (data: SelectedProduct[], orderDirectly: boolean, successCb?: () => void) =>
    action(ADD_CART, { data, orderDirectly, successCb });
export const orderAgain = (data: CustomerOrder, orderDirectly: boolean) => action(ORDER_AGAIN, { data, orderDirectly });
export const removeFromCart = (product: SelectedProduct) => action(REMOVE_FROM_CART, { product });
export const removeAllFromCart = () => action(REMOVE_ALL_FROM_CART);
export const changeQuantity = (product: SelectedProduct, quantity: number) =>
    action(CHANGE_PRODUCT_QUANTITY, { product, quantity });
export const changeCustomFieldValue = (product: SelectedProduct, fieldName: string, value: string) =>
    action(CHANGE_PRODUCT_CUSTOM_FIELD_VALUE, { product, fieldName, value });
export const updateShoppingCart = (
    data?: SubmitBookingFormData,
    fromLandingPage?: boolean,
    fromLandingPageId?: string
) => action(UPDATE_SHOPPING_CART, { data, fromLandingPage, fromLandingPageId });
export const clearShoppingCart = (onSuccess?: () => void, onError?: () => void) =>
    action(CLEAR_SHOPPING_CART, { onSuccess, onError });
export const submitBooking = (data: SubmitBookingFormData) => action(SUBMIT_BOOKING, { data });
/** Drops the cart locally — no calc, so no request with a token that is about to end. */
export const resetShoppingCart = () => action(RESET_SHOPPING_CART);

/**
 * Request ordering/calc (add shopping cart request is pending)
 */
export const requestOrderingCalc = () => action(REQUEST_ORDERING_CALC);

/**
 * Success ordering/calc (populated shopping cart has been returned successfully)
 */
export const successOrderingCalc = (response: any, containsOrderDirectlyProduct: boolean) =>
    action(SUCCESS_ORDERING_CALC, { response, containsOrderDirectlyProduct });

/**
 * Failure ordering/calc (error on populating shopping cart)
 */
export const failureOrderingCalc = (error: any) => action(FAILURE_ORDERING_CALC, { error });

export const successSubmitBooking = () => action(SUCCESS_SUBMIT_BOOKING, {});
